import UsetStats from "../../components/dashboard/userStats/UsersStats"

const UserStatPage = () => {
    
    return <UsetStats />
}

export default UserStatPage